export default __webpack_public_path__ + "static/media/shippable.6338a157.svg";